




// // import React, { useState, useEffect } from "react";
// // import { useNavigate, useParams } from "react-router-dom";
// // import { Editor } from "@tinymce/tinymce-react";
// // import { message, Spin } from "antd";
// // import {
// //     BookOutlined,
// //     FileImageOutlined,
// //     TagsOutlined,
// //     EyeOutlined,
// //     EditOutlined,
// //     SaveOutlined,
// //     InfoCircleOutlined,
// //     ClockCircleOutlined,
// //     TeamOutlined,
// //     FileTextOutlined,
// //     RocketOutlined,
// //     DollarOutlined,
// //     VideoCameraOutlined,
// // } from "@ant-design/icons";
// // import courseService from "../../../services/course.service";
// // import liveTrainingService from "../../../services/liveTraining.service";

// // // 🎨 COULEURS NOMIDYA
// // const C = {
// //     blue: "#0054A6",
// //     blueDark: "#003B75",
// //     blueDeep: "#002147",
// //     orange: "#E8860C",
// //     orangeLight: "#FF8C00",
// //     orangeDark: "#C46F0A",
// // };

// // const INITIAL_VALUE = {
// //     title: "",
// //     image: "",
// //     duration: "",
// //     short_desc: "",
// //     overview: "",
// //     requirements: "",
// //     what_you_will_learn: "",
// //     who_is_this_course_for: "",
// //     price: 0,
// // };

// // const LiveTrainingForm = ({ btnText, initialData, onClose, onSaved }) => {
// //     const { id: paramId } = useParams();
// //     const editId = initialData?.id || paramId;

// //     const [liveTraining, setLiveTraining] = useState(INITIAL_VALUE);
// //     const [imagePreview, setImagePreview] = useState("");
// //     const navigate = useNavigate();
// //     const [isSubmitting, setIsSubmitting] = useState(false);
// //     const [isLoadingData, setIsLoadingData] = useState(false);
// //     const [categories, setCategories] = useState([]);
// //     const [subcategories, setSubcategories] = useState([]);
// //     const [selectedCategory, setSelectedCategory] = useState("");
// //     const [imageFile, setImageFile] = useState(null);

// //     const calculateProgress = () => {
// //         let filled = 0;
// //         const total = 4;
// //         if (liveTraining.title) filled++;
// //         if (liveTraining.short_desc) filled++;
// //         if (selectedCategory) filled++;
// //         if (liveTraining.price > 0) filled++;
// //         return Math.round((filled / total) * 100);
// //     };

// //     // ⭐ Charger les données en mode édition
// //     useEffect(() => {
// //         if (editId) {
// //             const fetchData = async () => {
// //                 try {
// //                     setIsLoadingData(true);
// //                     console.log("📡 Chargement de la formation ID:", editId);
// //                     const fullData = await (
// //                         liveTrainingService.getByIdForAdmin
// //                             ? liveTrainingService.getByIdForAdmin(editId)
// //                             : liveTrainingService.getById(editId)
// //                     );
// //                     console.log("✅ Données chargées:", fullData);

// //                     setLiveTraining({
// //                         ...INITIAL_VALUE,
// //                         ...fullData,
// //                     });
// //                     setImagePreview(fullData.image || "");
// //                     setSelectedCategory(fullData.category?.id || "");

// //                     if (fullData.category?.id) {
// //                         const subs = await courseService.getSubcategories(fullData.category.id);
// //                         setSubcategories(subs);
// //                     }
// //                 } catch (error) {
// //                     console.error("❌ Erreur chargement formation live:", error);
// //                     message.error("Erreur lors du chargement de la formation");
// //                 } finally {
// //                     setIsLoadingData(false);
// //                 }
// //             };
// //             fetchData();
// //         }
// //     }, [editId]);

// //     useEffect(() => {
// //         const fetchCategories = async () => {
// //             try {
// //                 const response = await courseService.getCategories();
// //                 if (Array.isArray(response)) {
// //                     setCategories(response);
// //                 }
// //             } catch (error) {
// //                 console.error("Erreur chargement catégories:", error);
// //             }
// //         };
// //         fetchCategories();
// //     }, []);

// //     const handleCategoryChange = async (e) => {
// //         const categoryId = e.target.value;
// //         setSelectedCategory(categoryId);
// //         setLiveTraining((prev) => ({ ...prev, category: { id: categoryId } }));

// //         try {
// //             const response = await courseService.getSubcategories(categoryId);
// //             setSubcategories(response);
// //         } catch (error) {
// //             console.error("Erreur sous-catégories:", error);
// //         }
// //     };

// //     const handleInputChange = (e) => {
// //         const { name, value, files, type } = e.target;
// //         if (name === "image" && files && files.length > 0) {
// //             setImageFile(files[0]);
// //             setImagePreview(URL.createObjectURL(files[0]));
// //         } else {
// //             let processedValue = value;
// //             if (type === "number") {
// //                 processedValue = value === "" ? 0 : parseFloat(value) || 0;
// //             }
// //             setLiveTraining((prev) => ({ ...prev, [name]: processedValue }));
// //         }
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();

// //         if (!liveTraining.title) {
// //             message.error("Veuillez fournir un titre");
// //             return;
// //         }
// //         if (!selectedCategory) {
// //             message.error("Veuillez sélectionner une catégorie");
// //             return;
// //         }
// //         if (!editId && !imageFile) {
// //             message.error("Veuillez fournir une image");
// //             return;
// //         }

// //         try {
// //             setIsSubmitting(true);

// //             const dataToSend = {
// //                 ...liveTraining,
// //                 category: { id: selectedCategory },
// //                 subcategory:
// //                     liveTraining.subcategory?.id
// //                         ? { id: liveTraining.subcategory.id }
// //                         : null,
// //             };

// //             if (!imageFile && !editId) {
// //                 delete dataToSend.image;
// //             }

// //             if (editId) {
// //                 await liveTrainingService.updateLiveTraining(editId, dataToSend, imageFile);
// //                 message.success("Formation live mise à jour avec succès !");
// //             } else {
// //                 await liveTrainingService.createLiveTraining(dataToSend, imageFile);
// //                 message.success("Formation live créée avec succès !");
// //             }

// //             if (onSaved) {
// //                 onSaved();
// //             } else {
// //                 setTimeout(() => {
// //                     navigate("/mod/live-trainings", { replace: true });
// //                 }, 1500);
// //             }
// //         } catch (error) {
// //             console.error("Erreur soumission:", error);
// //             message.error(error.message || "Erreur lors de l'opération");
// //         } finally {
// //             setIsSubmitting(false);
// //         }
// //     };

// //     const progress = calculateProgress();

// //     return (
// //         <div style={{ minHeight: "100vh", background: "#f0f2f5", padding: "0" }}>
// //             <style>{`
// //                 :root {
// //                     --primary-color: ${C.blue};
// //                     --orange: ${C.orange};
// //                     --success-color: #52c41a;
// //                     --error-color: #ff4d4f;
// //                     --text-primary: #262626;
// //                     --text-secondary: #595959;
// //                     --text-muted: #8c8c8c;
// //                     --border-color: #d9d9d9;
// //                     --bg-light: #fafafa;
// //                     --shadow-sm: 0 1px 2px rgba(0,0,0,0.03), 0 1px 6px -1px rgba(0,0,0,0.02);
// //                     --shadow-md: 0 6px 16px rgba(0,84,166,0.1);
// //                     --radius-md: 8px;
// //                     --radius-lg: 12px;
// //                 }

// //                 .live-form-header {
// //                     background: linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%);
// //                     padding: 24px 32px;
// //                     color: white;
// //                     position: sticky;
// //                     top: 0;
// //                     z-index: 100;
// //                     box-shadow: 0 4px 20px rgba(0,84,166,0.25);
// //                     overflow: hidden;
// //                 }
// //                 .live-form-header::before {
// //                     content: '';
// //                     position: absolute;
// //                     top: 0; left: 0;
// //                     width: 100%; height: 100%;
// //                     background-image: radial-gradient(circle at 80% 30%, ${C.orange}22 0%, transparent 50%);
// //                     pointer-events: none;
// //                 }

// //                 .header-content {
// //                     max-width: 1400px;
// //                     margin: 0 auto;
// //                     display: flex;
// //                     justify-content: space-between;
// //                     align-items: center;
// //                     flex-wrap: wrap;
// //                     gap: 16px;
// //                     position: relative;
// //                     z-index: 1;
// //                 }

// //                 .header-title {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 12px;
// //                 }

// //                 .header-title h1 {
// //                     margin: 0;
// //                     font-size: 24px;
// //                     font-weight: 600;
// //                 }

// //                 .header-title .icon {
// //                     font-size: 28px;
// //                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
// //                     padding: 8px;
// //                     border-radius: 8px;
// //                     box-shadow: 0 4px 12px ${C.orange}66;
// //                 }

// //                 .live-badge {
// //                     background: rgba(255,0,0,0.95);
// //                     padding: 4px 12px;
// //                     border-radius: 20px;
// //                     font-size: 12px;
// //                     font-weight: 600;
// //                     text-transform: uppercase;
// //                     letter-spacing: 1px;
// //                     display: inline-flex;
// //                     align-items: center;
// //                     gap: 6px;
// //                 }
// //                 .live-badge::before {
// //                     content: '';
// //                     width: 8px;
// //                     height: 8px;
// //                     background: white;
// //                     border-radius: 50%;
// //                     animation: pulse 1.5s infinite;
// //                 }
// //                 @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }

// //                 .progress-indicator {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 10px;
// //                     background: rgba(255,255,255,0.15);
// //                     padding: 8px 16px;
// //                     border-radius: 20px;
// //                     backdrop-filter: blur(10px);
// //                 }

// //                 .progress-bar-container {
// //                     width: 120px;
// //                     height: 6px;
// //                     background: rgba(255,255,255,0.3);
// //                     border-radius: 3px;
// //                     overflow: hidden;
// //                 }

// //                 .progress-bar-fill {
// //                     height: 100%;
// //                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
// //                     border-radius: 3px;
// //                     transition: width 0.3s ease;
// //                 }

// //                 .progress-text {
// //                     font-size: 13px;
// //                     font-weight: 500;
// //                 }

// //                 .live-form-container {
// //                     max-width: 1100px;
// //                     margin: 0 auto;
// //                     padding: 24px;
// //                 }

// //                 .form-section {
// //                     background: white;
// //                     border-radius: var(--radius-lg);
// //                     box-shadow: var(--shadow-sm);
// //                     border: 1px solid #f0f0f0;
// //                     overflow: hidden;
// //                     margin-bottom: 24px;
// //                     transition: box-shadow 0.2s ease;
// //                 }
// //                 .form-section:hover {
// //                     box-shadow: var(--shadow-md);
// //                 }

// //                 .section-header {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 14px;
// //                     padding: 20px 24px;
// //                     border-bottom: 1px solid #f0f0f0;
// //                     background: var(--bg-light);
// //                 }

// //                 .section-icon {
// //                     width: 44px;
// //                     height: 44px;
// //                     border-radius: 10px;
// //                     display: flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     font-size: 20px;
// //                     color: white;
// //                 }

// //                 .section-icon.live { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
// //                 .section-icon.primary { background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%); }
// //                 .section-icon.success { background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%); }
// //                 .section-icon.warning { background: linear-gradient(135deg, #faad14 0%, #d48806 100%); }
// //                 .section-icon.info { background: linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%); }
// //                 .section-icon.purple { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
// //                 .section-icon.pink { background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%); }

// //                 .section-title-group h3 {
// //                     margin: 0 0 4px 0;
// //                     font-size: 17px;
// //                     font-weight: 600;
// //                     color: var(--text-primary);
// //                 }
// //                 .section-title-group p {
// //                     margin: 0;
// //                     font-size: 13px;
// //                     color: var(--text-muted);
// //                 }

// //                 .section-content { padding: 24px; }

// //                 .form-row {
// //                     display: grid;
// //                     grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
// //                     gap: 20px;
// //                 }

// //                 .form-group { margin-bottom: 20px; }
// //                 .form-group:last-child { margin-bottom: 0; }

// //                 .form-label {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 8px;
// //                     margin-bottom: 8px;
// //                     font-size: 14px;
// //                     font-weight: 500;
// //                     color: var(--text-primary);
// //                 }
// //                 .form-label .required { color: var(--error-color); }
// //                 .form-label .label-icon {
// //                     color: ${C.blue};
// //                     font-size: 16px;
// //                 }

// //                 .form-input, .form-select, .form-textarea {
// //                     width: 100%;
// //                     padding: 10px 14px;
// //                     border: 1px solid var(--border-color);
// //                     border-radius: var(--radius-md);
// //                     font-size: 14px;
// //                     color: var(--text-primary);
// //                     background: white;
// //                     transition: all 0.2s ease;
// //                     box-sizing: border-box;
// //                 }
// //                 .form-input:focus, .form-select:focus, .form-textarea:focus {
// //                     outline: none;
// //                     border-color: ${C.blue};
// //                     box-shadow: 0 0 0 2px ${C.blue}22;
// //                 }
// //                 .form-textarea {
// //                     resize: vertical;
// //                     min-height: 100px;
// //                 }

// //                 .image-upload-area {
// //                     border: 2px dashed var(--border-color);
// //                     border-radius: var(--radius-md);
// //                     padding: 24px;
// //                     text-align: center;
// //                     cursor: pointer;
// //                     background: var(--bg-light);
// //                     transition: all 0.2s ease;
// //                 }
// //                 .image-upload-area:hover {
// //                     border-color: ${C.blue};
// //                     background: #f0f7ff;
// //                 }
// //                 .image-upload-area input[type="file"] { display: none; }

// //                 .upload-icon {
// //                     font-size: 40px;
// //                     color: ${C.blue};
// //                     margin-bottom: 12px;
// //                 }
// //                 .upload-text { font-size: 14px; color: var(--text-secondary); }
// //                 .upload-hint { font-size: 12px; color: var(--text-muted); margin-top: 6px; }

// //                 .image-preview {
// //                     max-width: 200px;
// //                     max-height: 150px;
// //                     border-radius: var(--radius-md);
// //                     box-shadow: var(--shadow-sm);
// //                     margin-top: 16px;
// //                     border: 1px solid #f0f0f0;
// //                 }

// //                 .editor-wrapper {
// //                     border: 1px solid var(--border-color);
// //                     border-radius: var(--radius-md);
// //                     overflow: hidden;
// //                 }
// //                 .editor-wrapper:focus-within {
// //                     border-color: ${C.blue};
// //                     box-shadow: 0 0 0 2px ${C.blue}22;
// //                 }

// //                 .price-input-group { position: relative; }
// //                 .price-input-group .currency-symbol {
// //                     position: absolute;
// //                     left: 14px;
// //                     top: 50%;
// //                     transform: translateY(-50%);
// //                     color: ${C.orange};
// //                     font-weight: 700;
// //                 }
// //                 .price-input-group .form-input { padding-left: 32px; }

// //                 .submit-section {
// //                     background: white;
// //                     border-radius: var(--radius-lg);
// //                     box-shadow: var(--shadow-sm);
// //                     border: 1px solid #f0f0f0;
// //                     padding: 24px;
// //                     display: flex;
// //                     justify-content: space-between;
// //                     align-items: center;
// //                     flex-wrap: wrap;
// //                     gap: 16px;
// //                 }

// //                 .submit-info {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 12px;
// //                     color: var(--text-muted);
// //                     font-size: 14px;
// //                 }

// //                 .submit-actions { display: flex; gap: 12px; }

// //                 .btn {
// //                     display: inline-flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     gap: 8px;
// //                     padding: 12px 28px;
// //                     border-radius: var(--radius-md);
// //                     font-size: 15px;
// //                     font-weight: 500;
// //                     cursor: pointer;
// //                     transition: all 0.2s ease;
// //                     border: none;
// //                     min-width: 160px;
// //                 }

// //                 .btn-primary {
// //                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
// //                     color: white;
// //                     box-shadow: 0 4px 12px ${C.orange}66;
// //                 }
// //                 .btn-primary:hover:not(:disabled) {
// //                     transform: translateY(-2px);
// //                     box-shadow: 0 6px 20px ${C.orange}88;
// //                     background: linear-gradient(135deg, ${C.orangeDark} 0%, ${C.orange} 100%);
// //                 }
// //                 .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

// //                 .btn-secondary {
// //                     background: white;
// //                     color: ${C.blue};
// //                     border: 2px solid ${C.blue};
// //                 }
// //                 .btn-secondary:hover {
// //                     background: #f0f7ff;
// //                     border-color: ${C.blueDark};
// //                     color: ${C.blueDark};
// //                 }

// //                 .loading-overlay {
// //                     position: fixed;
// //                     top: 0; left: 0;
// //                     width: 100%; height: 100%;
// //                     background: rgba(0,33,71,0.45);
// //                     display: flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     z-index: 9999;
// //                     backdrop-filter: blur(4px);
// //                 }

// //                 .loading-card {
// //                     background: white;
// //                     padding: 40px 50px;
// //                     border-radius: var(--radius-lg);
// //                     text-align: center;
// //                     box-shadow: 0 20px 40px rgba(0,84,166,0.25);
// //                 }

// //                 .loading-text {
// //                     margin-top: 20px;
// //                     font-size: 16px;
// //                     font-weight: 500;
// //                     color: ${C.blueDark};
// //                 }

// //                 @media (max-width: 768px) {
// //                     .live-form-header { padding: 16px 20px; }
// //                     .header-title h1 { font-size: 18px; }
// //                     .live-form-container { padding: 16px; }
// //                     .section-content { padding: 16px; }
// //                     .form-row { grid-template-columns: 1fr; }
// //                     .submit-section { flex-direction: column; align-items: stretch; }
// //                     .submit-actions { flex-direction: column; }
// //                     .btn { width: 100%; }
// //                 }
// //             `}</style>

// //             {/* ⭐ LOADER PENDANT LE CHARGEMENT DES DONNÉES (mode édition) */}
// //             {isLoadingData && (
// //                 <div className="loading-overlay">
// //                     <div className="loading-card">
// //                         <Spin size="large" />
// //                         <div className="loading-text">
// //                             Chargement de la formation...
// //                         </div>
// //                         <div style={{ marginTop: 8, fontSize: 13, color: '#9ca3af' }}>
// //                             Veuillez patienter quelques instants
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Loading Overlay */}
// //             {isSubmitting && (
// //                 <div className="loading-overlay">
// //                     <div className="loading-card">
// //                         <Spin size="large" />
// //                         <div className="loading-text">
// //                             {editId ? "Mise à jour en cours..." : "Création en cours..."}
// //                         </div>
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Header BLEU NOMIDYA */}
// //             <div className="live-form-header">
// //                 <div className="header-content">
// //                     <div className="header-title">
// //                         <span className="icon"><VideoCameraOutlined /></span>
// //                         <div>
// //                             <h1>{editId ? `Modifier : ${liveTraining.title || ""}` : "Créer une Formation Live"}</h1>
// //                             <span className="live-badge">LIVE</span>
// //                         </div>
// //                     </div>
// //                     <div className="progress-indicator">
// //                         <span className="progress-text">Progression</span>
// //                         <div className="progress-bar-container">
// //                             <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
// //                         </div>
// //                         <span className="progress-text">{progress}%</span>
// //                     </div>
// //                 </div>
// //             </div>

// //             <div className="live-form-container">
// //                 <form onSubmit={handleSubmit}>

// //                     {/* SECTION 1 : Informations principales */}
// //                     <div className="form-section">
// //                         <div className="section-header">
// //                             <div className="section-icon primary"><BookOutlined /></div>
// //                             <div className="section-title-group">
// //                                 <h3>Informations principales</h3>
// //                                 <p>Titre, prix, image et description</p>
// //                             </div>
// //                         </div>
// //                         <div className="section-content">
// //                             <div className="form-row">
// //                                 <div className="form-group">
// //                                     <label className="form-label">
// //                                         <EditOutlined className="label-icon" />
// //                                         Titre <span className="required">*</span>
// //                                     </label>
// //                                     <input
// //                                         type="text"
// //                                         name="title"
// //                                         className="form-input"
// //                                         value={liveTraining.title}
// //                                         onChange={handleInputChange}
// //                                         placeholder="Ex: Masterclass SAP S/4HANA Live"
// //                                         required
// //                                     />
// //                                 </div>

// //                                 <div className="form-group">
// //                                     <label className="form-label">
// //                                         <DollarOutlined className="label-icon" />
// //                                         Prix de la formation <span className="required">*</span>
// //                                     </label>
// //                                     <div className="price-input-group">
// //                                         <span className="currency-symbol">€</span>
// //                                         <input
// //                                             type="number"
// //                                             name="price"
// //                                             className="form-input"
// //                                             value={liveTraining.price}
// //                                             onChange={handleInputChange}
// //                                             min="0"
// //                                             step="0.01"
// //                                             placeholder="Ex: 99.99"
// //                                             required
// //                                         />
// //                                     </div>
// //                                 </div>
// //                             </div>

// //                             <div className="form-group">
// //                                 <label className="form-label">
// //                                     <FileImageOutlined className="label-icon" />
// //                                     Image de couverture {!editId && <span className="required">*</span>}
// //                                 </label>
// //                                 <label className="image-upload-area">
// //                                     <input
// //                                         type="file"
// //                                         name="image"
// //                                         onChange={handleInputChange}
// //                                         accept="image/*"
// //                                     />
// //                                     <div className="upload-icon"><FileImageOutlined /></div>
// //                                     <div className="upload-text">Cliquez pour télécharger</div>
// //                                     <div className="upload-hint">PNG, JPG jusqu'à 5MB</div>
// //                                 </label>
// //                                 {imagePreview && (
// //                                     <img src={imagePreview} alt="Preview" className="image-preview" />
// //                                 )}
// //                             </div>

// //                             <div className="form-group">
// //                                 <label className="form-label">
// //                                     <FileTextOutlined className="label-icon" />
// //                                     Description courte
// //                                 </label>
// //                                 <textarea
// //                                     name="short_desc"
// //                                     className="form-textarea"
// //                                     value={liveTraining.short_desc}
// //                                     onChange={handleInputChange}
// //                                     placeholder="Décrivez votre formation live..."
// //                                     rows="3"
// //                                 />
// //                             </div>

// //                             <div className="form-group">
// //                                 <label className="form-label">
// //                                     <ClockCircleOutlined className="label-icon" />
// //                                     Durée totale
// //                                 </label>
// //                                 <input
// //                                     type="text"
// //                                     name="duration"
// //                                     className="form-input"
// //                                     value={liveTraining.duration}
// //                                     onChange={handleInputChange}
// //                                     placeholder="Ex: 3h, 2 jours"
// //                                 />
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* SECTION 2 : Catégorisation */}
// //                     <div className="form-section">
// //                         <div className="section-header">
// //                             <div className="section-icon warning"><TagsOutlined /></div>
// //                             <div className="section-title-group">
// //                                 <h3>Catégorisation</h3>
// //                                 <p>Classez votre formation</p>
// //                             </div>
// //                         </div>
// //                         <div className="section-content">
// //                             <div className="form-row">
// //                                 <div className="form-group">
// //                                     <label className="form-label">
// //                                         <TagsOutlined className="label-icon" />
// //                                         Catégorie <span className="required">*</span>
// //                                     </label>
// //                                     <select
// //                                         className="form-select"
// //                                         value={selectedCategory || ""}
// //                                         onChange={handleCategoryChange}
// //                                         required
// //                                     >
// //                                         <option value="">Sélectionnez une catégorie</option>
// //                                         {categories.map((cat) => (
// //                                             <option key={cat.id} value={cat.id}>
// //                                                 {cat.libelle}
// //                                             </option>
// //                                         ))}
// //                                     </select>
// //                                 </div>

// //                                 <div className="form-group">
// //                                     <label className="form-label">
// //                                         <TagsOutlined className="label-icon" />
// //                                         Sous-catégorie
// //                                     </label>
// //                                     <select
// //                                         className="form-select"
// //                                         value={liveTraining.subcategory?.id || ""}
// //                                         onChange={(e) =>
// //                                             setLiveTraining((prev) => ({
// //                                                 ...prev,
// //                                                 subcategory: e.target.value
// //                                                     ? { id: parseInt(e.target.value, 10) }
// //                                                     : null,
// //                                             }))
// //                                         }
// //                                         disabled={!subcategories.length}
// //                                     >
// //                                         <option value="">Sélectionnez une sous-catégorie</option>
// //                                         {subcategories.map((sub) => (
// //                                             <option key={sub.id} value={sub.id}>
// //                                                 {sub.libelle}
// //                                             </option>
// //                                         ))}
// //                                     </select>
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* SECTION 3 : Aperçu */}
// //                     <div className="form-section">
// //                         <div className="section-header">
// //                             <div className="section-icon info"><EyeOutlined /></div>
// //                             <div className="section-title-group">
// //                                 <h3>Aperçu de la formation</h3>
// //                                 <p>Présentez votre session live</p>
// //                             </div>
// //                         </div>
// //                         <div className="section-content">
// //                             <div className="editor-wrapper">
// //                                 <Editor
// //                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
// //                                     value={liveTraining.overview}
// //                                     init={{
// //                                         height: 280,
// //                                         menubar: false,
// //                                         plugins: ["link", "lists", "table", "paste", "code"],
// //                                         toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link",
// //                                     }}
// //                                     onEditorChange={(content) =>
// //                                         handleInputChange({ target: { name: "overview", value: content } })
// //                                     }
// //                                 />
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* SECTION 4 : Contenu */}
// //                     <div className="form-section">
// //                         <div className="section-header">
// //                             <div className="section-icon purple"><RocketOutlined /></div>
// //                             <div className="section-title-group">
// //                                 <h3>Ce que vous allez apprendre</h3>
// //                                 <p>Compétences acquises</p>
// //                             </div>
// //                         </div>
// //                         <div className="section-content">
// //                             <div className="editor-wrapper">
// //                                 <Editor
// //                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
// //                                     value={liveTraining.what_you_will_learn}
// //                                     init={{
// //                                         height: 250,
// //                                         menubar: false,
// //                                         plugins: ["link", "lists", "paste"],
// //                                         toolbar: "undo redo | bold italic | bullist numlist",
// //                                     }}
// //                                     onEditorChange={(content) =>
// //                                         handleInputChange({ target: { name: "what_you_will_learn", value: content } })
// //                                     }
// //                                 />
// //                             </div>

// //                             <div className="form-group" style={{ marginTop: 24 }}>
// //                                 <label className="form-label">
// //                                     <FileTextOutlined className="label-icon" />
// //                                     Prérequis
// //                                 </label>
// //                                 <div className="editor-wrapper">
// //                                     <Editor
// //                                         apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
// //                                         value={liveTraining.requirements}
// //                                         init={{
// //                                             height: 200,
// //                                             menubar: false,
// //                                             plugins: ["link", "lists", "paste"],
// //                                             toolbar: "undo redo | bold italic | bullist numlist",
// //                                         }}
// //                                         onEditorChange={(content) =>
// //                                             handleInputChange({ target: { name: "requirements", value: content } })
// //                                         }
// //                                     />
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* SECTION 5 : Public cible */}
// //                     <div className="form-section">
// //                         <div className="section-header">
// //                             <div className="section-icon pink"><TeamOutlined /></div>
// //                             <div className="section-title-group">
// //                                 <h3>Public cible</h3>
// //                                 <p>À qui s'adresse cette formation ?</p>
// //                             </div>
// //                         </div>
// //                         <div className="section-content">
// //                             <div className="editor-wrapper">
// //                                 <Editor
// //                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
// //                                     value={liveTraining.who_is_this_course_for}
// //                                     init={{
// //                                         height: 200,
// //                                         menubar: false,
// //                                         plugins: ["link", "lists", "paste"],
// //                                         toolbar: "undo redo | bold italic | bullist numlist",
// //                                     }}
// //                                     onEditorChange={(content) =>
// //                                         handleInputChange({ target: { name: "who_is_this_course_for", value: content } })
// //                                     }
// //                                 />
// //                             </div>
// //                         </div>
// //                     </div>

// //                     {/* SUBMIT */}
// //                     <div className="submit-section">
// //                         <div className="submit-info">
// //                             <InfoCircleOutlined style={{ color: C.blue }} />
// //                             <span>Les champs marqués d'un <span style={{ color: "#ff4d4f" }}>*</span> sont obligatoires</span>
// //                         </div>
// //                         <div className="submit-actions">
// //                             {onClose && (
// //                                 <button type="button" className="btn btn-secondary" onClick={onClose}>
// //                                     Annuler
// //                                 </button>
// //                             )}
// //                             <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
// //                                 {isSubmitting ? (
// //                                     <><Spin size="small" /> Envoi...</>
// //                                 ) : (
// //                                     <><SaveOutlined /> {editId ? "Mettre à jour" : "Créer la formation Live"}</>
// //                                 )}
// //                             </button>
// //                         </div>
// //                     </div>
// //                 </form>
// //             </div>
// //         </div>
// //     );
// // };

// // export default LiveTrainingForm;



// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { Editor } from "@tinymce/tinymce-react";
// import { message, Spin } from "antd";
// import {
//     BookOutlined,
//     FileImageOutlined,
//     TagsOutlined,
//     EyeOutlined,
//     EditOutlined,
//     SaveOutlined,
//     InfoCircleOutlined,
//     ClockCircleOutlined,
//     TeamOutlined,
//     FileTextOutlined,
//     RocketOutlined,
//     DollarOutlined,
//     VideoCameraOutlined,
// } from "@ant-design/icons";
// import courseService from "../../../services/course.service";
// import liveTrainingService from "../../../services/liveTraining.service";

// // 🎨 COULEURS NOMIDYA
// const C = {
//     blue: "#0054A6",
//     blueDark: "#003B75",
//     blueDeep: "#002147",
//     orange: "#E8860C",
//     orangeLight: "#FF8C00",
//     orangeDark: "#C46F0A",
// };

// const INITIAL_VALUE = {
//     title: "",
//     image: "",
//     duration: "",
//     short_desc: "",
//     overview: "",
//     requirements: "",
//     what_you_will_learn: "",
//     who_is_this_course_for: "",
//     price: 0,
// };

// const LiveTrainingForm = ({ btnText, initialData, onClose, onSaved }) => {
//     const { id: paramId } = useParams();
//     const editId = initialData?.id || paramId;

//     const [liveTraining, setLiveTraining] = useState(INITIAL_VALUE);
//     const [imagePreview, setImagePreview] = useState("");
//     const navigate = useNavigate();
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isLoadingData, setIsLoadingData] = useState(false);
//     const [categories, setCategories] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState("");
//     const [imageFile, setImageFile] = useState(null);

//     const calculateProgress = () => {
//         let filled = 0;
//         const total = 4;
//         if (liveTraining.title) filled++;
//         if (liveTraining.short_desc) filled++;
//         if (selectedCategory) filled++;
//         if (liveTraining.price > 0) filled++;
//         return Math.round((filled / total) * 100);
//     };

//     // ⭐ Charger les données en mode édition
//     useEffect(() => {
//         if (editId) {
//             const fetchData = async () => {
//                 try {
//                     setIsLoadingData(true);
//                     console.log("📡 Chargement de la formation ID:", editId);
//                     const fullData = await (
//                         liveTrainingService.getByIdForAdmin
//                             ? liveTrainingService.getByIdForAdmin(editId)
//                             : liveTrainingService.getById(editId)
//                     );
//                     console.log("✅ Données chargées:", fullData);

//                     setLiveTraining({
//                         ...INITIAL_VALUE,
//                         ...fullData,
//                     });
//                     setImagePreview(fullData.image || "");
//                     setSelectedCategory(fullData.category?.id || "");

//                     if (fullData.category?.id) {
//                         const subs = await courseService.getSubcategories(fullData.category.id);
//                         setSubcategories(subs);
//                     }
//                 } catch (error) {
//                     console.error("❌ Erreur chargement formation live:", error);
//                     message.error("Erreur lors du chargement de la formation");
//                 } finally {
//                     setIsLoadingData(false);
//                 }
//             };
//             fetchData();
//         }
//     }, [editId]);

//     useEffect(() => {
//         const fetchCategories = async () => {
//             try {
//                 const response = await courseService.getCategories();
//                 if (Array.isArray(response)) {
//                     setCategories(response);
//                 }
//             } catch (error) {
//                 console.error("Erreur chargement catégories:", error);
//             }
//         };
//         fetchCategories();
//     }, []);

//     const handleCategoryChange = async (e) => {
//         const categoryId = e.target.value;
//         setSelectedCategory(categoryId);
//         setLiveTraining((prev) => ({ ...prev, category: { id: categoryId } }));

//         try {
//             const response = await courseService.getSubcategories(categoryId);
//             setSubcategories(response);
//         } catch (error) {
//             console.error("Erreur sous-catégories:", error);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value, files, type } = e.target;
//         if (name === "image" && files && files.length > 0) {
//             setImageFile(files[0]);
//             setImagePreview(URL.createObjectURL(files[0]));
//         } else {
//             let processedValue = value;
//             if (type === "number") {
//                 processedValue = value === "" ? 0 : parseFloat(value) || 0;
//             }
//             setLiveTraining((prev) => ({ ...prev, [name]: processedValue }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!liveTraining.title) {
//             message.error("Veuillez fournir un titre");
//             return;
//         }
//         if (!selectedCategory) {
//             message.error("Veuillez sélectionner une catégorie");
//             return;
//         }
//         if (!editId && !imageFile) {
//             message.error("Veuillez fournir une image");
//             return;
//         }

//         try {
//             setIsSubmitting(true);

//             const dataToSend = {
//                 ...liveTraining,
//                 category: { id: selectedCategory },
//                 subcategory:
//                     liveTraining.subcategory?.id
//                         ? { id: liveTraining.subcategory.id }
//                         : null,
//             };

//             // ⭐⭐ CORRECTION CRITIQUE ⭐⭐
//             // L'image Base64 ne doit JAMAIS partir dans le JSON (paramètre multipart).
//             // En mode édition, liveTraining.image contient le Base64 complet de l'image
//             // existante (souvent > 1 Mo). Envoyé en paramètre POST, il dépasse la limite
//             // maxPostSize du connecteur Tomcat -> MultipartException -> "[object Object]".
//             //
//             // L'image transite UNIQUEMENT via imageFile (partie "file" du multipart).
//             // Le backend conserve l'image existante si aucun nouveau fichier n'est fourni.
//             delete dataToSend.image;

//             if (editId) {
//                 await liveTrainingService.updateLiveTraining(editId, dataToSend, imageFile);
//                 message.success("Formation live mise à jour avec succès !");
//             } else {
//                 await liveTrainingService.createLiveTraining(dataToSend, imageFile);
//                 message.success("Formation live créée avec succès !");
//             }

//             if (onSaved) {
//                 onSaved();
//             } else {
//                 setTimeout(() => {
//                     navigate("/mod/live-trainings", { replace: true });
//                 }, 1500);
//             }
//         } catch (error) {
//             console.error("Erreur soumission:", error);
//             message.error(error.message || "Erreur lors de l'opération");
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const progress = calculateProgress();

//     return (
//         <div style={{ minHeight: "100vh", background: "#f0f2f5", padding: "0" }}>
//             <style>{`
//                 :root {
//                     --primary-color: ${C.blue};
//                     --orange: ${C.orange};
//                     --success-color: #52c41a;
//                     --error-color: #ff4d4f;
//                     --text-primary: #262626;
//                     --text-secondary: #595959;
//                     --text-muted: #8c8c8c;
//                     --border-color: #d9d9d9;
//                     --bg-light: #fafafa;
//                     --shadow-sm: 0 1px 2px rgba(0,0,0,0.03), 0 1px 6px -1px rgba(0,0,0,0.02);
//                     --shadow-md: 0 6px 16px rgba(0,84,166,0.1);
//                     --radius-md: 8px;
//                     --radius-lg: 12px;
//                 }

//                 .live-form-header {
//                     background: linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%);
//                     padding: 24px 32px;
//                     color: white;
//                     position: sticky;
//                     top: 0;
//                     z-index: 100;
//                     box-shadow: 0 4px 20px rgba(0,84,166,0.25);
//                     overflow: hidden;
//                 }
//                 .live-form-header::before {
//                     content: '';
//                     position: absolute;
//                     top: 0; left: 0;
//                     width: 100%; height: 100%;
//                     background-image: radial-gradient(circle at 80% 30%, ${C.orange}22 0%, transparent 50%);
//                     pointer-events: none;
//                 }

//                 .header-content {
//                     max-width: 1400px;
//                     margin: 0 auto;
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     flex-wrap: wrap;
//                     gap: 16px;
//                     position: relative;
//                     z-index: 1;
//                 }

//                 .header-title {
//                     display: flex;
//                     align-items: center;
//                     gap: 12px;
//                 }

//                 .header-title h1 {
//                     margin: 0;
//                     font-size: 24px;
//                     font-weight: 600;
//                 }

//                 .header-title .icon {
//                     font-size: 28px;
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     padding: 8px;
//                     border-radius: 8px;
//                     box-shadow: 0 4px 12px ${C.orange}66;
//                 }

//                 .live-badge {
//                     background: rgba(255,0,0,0.95);
//                     padding: 4px 12px;
//                     border-radius: 20px;
//                     font-size: 12px;
//                     font-weight: 600;
//                     text-transform: uppercase;
//                     letter-spacing: 1px;
//                     display: inline-flex;
//                     align-items: center;
//                     gap: 6px;
//                 }
//                 .live-badge::before {
//                     content: '';
//                     width: 8px;
//                     height: 8px;
//                     background: white;
//                     border-radius: 50%;
//                     animation: pulse 1.5s infinite;
//                 }
//                 @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }

//                 .progress-indicator {
//                     display: flex;
//                     align-items: center;
//                     gap: 10px;
//                     background: rgba(255,255,255,0.15);
//                     padding: 8px 16px;
//                     border-radius: 20px;
//                     backdrop-filter: blur(10px);
//                 }

//                 .progress-bar-container {
//                     width: 120px;
//                     height: 6px;
//                     background: rgba(255,255,255,0.3);
//                     border-radius: 3px;
//                     overflow: hidden;
//                 }

//                 .progress-bar-fill {
//                     height: 100%;
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     border-radius: 3px;
//                     transition: width 0.3s ease;
//                 }

//                 .progress-text {
//                     font-size: 13px;
//                     font-weight: 500;
//                 }

//                 .live-form-container {
//                     max-width: 1100px;
//                     margin: 0 auto;
//                     padding: 24px;
//                 }

//                 .form-section {
//                     background: white;
//                     border-radius: var(--radius-lg);
//                     box-shadow: var(--shadow-sm);
//                     border: 1px solid #f0f0f0;
//                     overflow: hidden;
//                     margin-bottom: 24px;
//                     transition: box-shadow 0.2s ease;
//                 }
//                 .form-section:hover {
//                     box-shadow: var(--shadow-md);
//                 }

//                 .section-header {
//                     display: flex;
//                     align-items: center;
//                     gap: 14px;
//                     padding: 20px 24px;
//                     border-bottom: 1px solid #f0f0f0;
//                     background: var(--bg-light);
//                 }

//                 .section-icon {
//                     width: 44px;
//                     height: 44px;
//                     border-radius: 10px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     font-size: 20px;
//                     color: white;
//                 }

//                 .section-icon.live { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
//                 .section-icon.primary { background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%); }
//                 .section-icon.success { background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%); }
//                 .section-icon.warning { background: linear-gradient(135deg, #faad14 0%, #d48806 100%); }
//                 .section-icon.info { background: linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%); }
//                 .section-icon.purple { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
//                 .section-icon.pink { background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%); }

//                 .section-title-group h3 {
//                     margin: 0 0 4px 0;
//                     font-size: 17px;
//                     font-weight: 600;
//                     color: var(--text-primary);
//                 }
//                 .section-title-group p {
//                     margin: 0;
//                     font-size: 13px;
//                     color: var(--text-muted);
//                 }

//                 .section-content { padding: 24px; }

//                 .form-row {
//                     display: grid;
//                     grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//                     gap: 20px;
//                 }

//                 .form-group { margin-bottom: 20px; }
//                 .form-group:last-child { margin-bottom: 0; }

//                 .form-label {
//                     display: flex;
//                     align-items: center;
//                     gap: 8px;
//                     margin-bottom: 8px;
//                     font-size: 14px;
//                     font-weight: 500;
//                     color: var(--text-primary);
//                 }
//                 .form-label .required { color: var(--error-color); }
//                 .form-label .label-icon {
//                     color: ${C.blue};
//                     font-size: 16px;
//                 }

//                 .form-input, .form-select, .form-textarea {
//                     width: 100%;
//                     padding: 10px 14px;
//                     border: 1px solid var(--border-color);
//                     border-radius: var(--radius-md);
//                     font-size: 14px;
//                     color: var(--text-primary);
//                     background: white;
//                     transition: all 0.2s ease;
//                     box-sizing: border-box;
//                 }
//                 .form-input:focus, .form-select:focus, .form-textarea:focus {
//                     outline: none;
//                     border-color: ${C.blue};
//                     box-shadow: 0 0 0 2px ${C.blue}22;
//                 }
//                 .form-textarea {
//                     resize: vertical;
//                     min-height: 100px;
//                 }

//                 .image-upload-area {
//                     border: 2px dashed var(--border-color);
//                     border-radius: var(--radius-md);
//                     padding: 24px;
//                     text-align: center;
//                     cursor: pointer;
//                     background: var(--bg-light);
//                     transition: all 0.2s ease;
//                 }
//                 .image-upload-area:hover {
//                     border-color: ${C.blue};
//                     background: #f0f7ff;
//                 }
//                 .image-upload-area input[type="file"] { display: none; }

//                 .upload-icon {
//                     font-size: 40px;
//                     color: ${C.blue};
//                     margin-bottom: 12px;
//                 }
//                 .upload-text { font-size: 14px; color: var(--text-secondary); }
//                 .upload-hint { font-size: 12px; color: var(--text-muted); margin-top: 6px; }

//                 .image-preview {
//                     max-width: 200px;
//                     max-height: 150px;
//                     border-radius: var(--radius-md);
//                     box-shadow: var(--shadow-sm);
//                     margin-top: 16px;
//                     border: 1px solid #f0f0f0;
//                 }

//                 .editor-wrapper {
//                     border: 1px solid var(--border-color);
//                     border-radius: var(--radius-md);
//                     overflow: hidden;
//                 }
//                 .editor-wrapper:focus-within {
//                     border-color: ${C.blue};
//                     box-shadow: 0 0 0 2px ${C.blue}22;
//                 }

//                 .price-input-group { position: relative; }
//                 .price-input-group .currency-symbol {
//                     position: absolute;
//                     left: 14px;
//                     top: 50%;
//                     transform: translateY(-50%);
//                     color: ${C.orange};
//                     font-weight: 700;
//                 }
//                 .price-input-group .form-input { padding-left: 32px; }

//                 .submit-section {
//                     background: white;
//                     border-radius: var(--radius-lg);
//                     box-shadow: var(--shadow-sm);
//                     border: 1px solid #f0f0f0;
//                     padding: 24px;
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;
//                     flex-wrap: wrap;
//                     gap: 16px;
//                 }

//                 .submit-info {
//                     display: flex;
//                     align-items: center;
//                     gap: 12px;
//                     color: var(--text-muted);
//                     font-size: 14px;
//                 }

//                 .submit-actions { display: flex; gap: 12px; }

//                 .btn {
//                     display: inline-flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 8px;
//                     padding: 12px 28px;
//                     border-radius: var(--radius-md);
//                     font-size: 15px;
//                     font-weight: 500;
//                     cursor: pointer;
//                     transition: all 0.2s ease;
//                     border: none;
//                     min-width: 160px;
//                 }

//                 .btn-primary {
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     color: white;
//                     box-shadow: 0 4px 12px ${C.orange}66;
//                 }
//                 .btn-primary:hover:not(:disabled) {
//                     transform: translateY(-2px);
//                     box-shadow: 0 6px 20px ${C.orange}88;
//                     background: linear-gradient(135deg, ${C.orangeDark} 0%, ${C.orange} 100%);
//                 }
//                 .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

//                 .btn-secondary {
//                     background: white;
//                     color: ${C.blue};
//                     border: 2px solid ${C.blue};
//                 }
//                 .btn-secondary:hover {
//                     background: #f0f7ff;
//                     border-color: ${C.blueDark};
//                     color: ${C.blueDark};
//                 }

//                 .loading-overlay {
//                     position: fixed;
//                     top: 0; left: 0;
//                     width: 100%; height: 100%;
//                     background: rgba(0,33,71,0.45);
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     z-index: 9999;
//                     backdrop-filter: blur(4px);
//                 }

//                 .loading-card {
//                     background: white;
//                     padding: 40px 50px;
//                     border-radius: var(--radius-lg);
//                     text-align: center;
//                     box-shadow: 0 20px 40px rgba(0,84,166,0.25);
//                 }

//                 .loading-text {
//                     margin-top: 20px;
//                     font-size: 16px;
//                     font-weight: 500;
//                     color: ${C.blueDark};
//                 }

//                 @media (max-width: 768px) {
//                     .live-form-header { padding: 16px 20px; }
//                     .header-title h1 { font-size: 18px; }
//                     .live-form-container { padding: 16px; }
//                     .section-content { padding: 16px; }
//                     .form-row { grid-template-columns: 1fr; }
//                     .submit-section { flex-direction: column; align-items: stretch; }
//                     .submit-actions { flex-direction: column; }
//                     .btn { width: 100%; }
//                 }
//             `}</style>

//             {/* ⭐ LOADER PENDANT LE CHARGEMENT DES DONNÉES (mode édition) */}
//             {isLoadingData && (
//                 <div className="loading-overlay">
//                     <div className="loading-card">
//                         <Spin size="large" />
//                         <div className="loading-text">
//                             Chargement de la formation...
//                         </div>
//                         <div style={{ marginTop: 8, fontSize: 13, color: '#9ca3af' }}>
//                             Veuillez patienter quelques instants
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Loading Overlay */}
//             {isSubmitting && (
//                 <div className="loading-overlay">
//                     <div className="loading-card">
//                         <Spin size="large" />
//                         <div className="loading-text">
//                             {editId ? "Mise à jour en cours..." : "Création en cours..."}
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Header BLEU NOMIDYA */}
//             <div className="live-form-header">
//                 <div className="header-content">
//                     <div className="header-title">
//                         <span className="icon"><VideoCameraOutlined /></span>
//                         <div>
//                             <h1>{editId ? `Modifier : ${liveTraining.title || ""}` : "Créer une Formation Live"}</h1>
//                             <span className="live-badge">LIVE</span>
//                         </div>
//                     </div>
//                     <div className="progress-indicator">
//                         <span className="progress-text">Progression</span>
//                         <div className="progress-bar-container">
//                             <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
//                         </div>
//                         <span className="progress-text">{progress}%</span>
//                     </div>
//                 </div>
//             </div>

//             <div className="live-form-container">
//                 <form onSubmit={handleSubmit}>

//                     {/* SECTION 1 : Informations principales */}
//                     <div className="form-section">
//                         <div className="section-header">
//                             <div className="section-icon primary"><BookOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Informations principales</h3>
//                                 <p>Titre, prix, image et description</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <EditOutlined className="label-icon" />
//                                         Titre <span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         name="title"
//                                         className="form-input"
//                                         value={liveTraining.title}
//                                         onChange={handleInputChange}
//                                         placeholder="Ex: Masterclass SAP S/4HANA Live"
//                                         required
//                                     />
//                                 </div>

//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <DollarOutlined className="label-icon" />
//                                         Prix de la formation <span className="required">*</span>
//                                     </label>
//                                     <div className="price-input-group">
//                                         <span className="currency-symbol">€</span>
//                                         <input
//                                             type="number"
//                                             name="price"
//                                             className="form-input"
//                                             value={liveTraining.price}
//                                             onChange={handleInputChange}
//                                             min="0"
//                                             step="0.01"
//                                             placeholder="Ex: 99.99"
//                                             required
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label">
//                                     <FileImageOutlined className="label-icon" />
//                                     Image de couverture {!editId && <span className="required">*</span>}
//                                 </label>
//                                 <label className="image-upload-area">
//                                     <input
//                                         type="file"
//                                         name="image"
//                                         onChange={handleInputChange}
//                                         accept="image/*"
//                                     />
//                                     <div className="upload-icon"><FileImageOutlined /></div>
//                                     <div className="upload-text">Cliquez pour télécharger</div>
//                                     <div className="upload-hint">
//                                         {editId
//                                             ? "Laissez vide pour conserver l'image actuelle"
//                                             : "PNG, JPG jusqu'à 5MB"}
//                                     </div>
//                                 </label>
//                                 {imagePreview && (
//                                     <img src={imagePreview} alt="Preview" className="image-preview" />
//                                 )}
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label">
//                                     <FileTextOutlined className="label-icon" />
//                                     Description courte
//                                 </label>
//                                 <textarea
//                                     name="short_desc"
//                                     className="form-textarea"
//                                     value={liveTraining.short_desc}
//                                     onChange={handleInputChange}
//                                     placeholder="Décrivez votre formation live..."
//                                     rows="3"
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <label className="form-label">
//                                     <ClockCircleOutlined className="label-icon" />
//                                     Durée totale
//                                 </label>
//                                 <input
//                                     type="text"
//                                     name="duration"
//                                     className="form-input"
//                                     value={liveTraining.duration}
//                                     onChange={handleInputChange}
//                                     placeholder="Ex: 3h, 2 jours"
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* SECTION 2 : Catégorisation */}
//                     <div className="form-section">
//                         <div className="section-header">
//                             <div className="section-icon warning"><TagsOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Catégorisation</h3>
//                                 <p>Classez votre formation</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <TagsOutlined className="label-icon" />
//                                         Catégorie <span className="required">*</span>
//                                     </label>
//                                     <select
//                                         className="form-select"
//                                         value={selectedCategory || ""}
//                                         onChange={handleCategoryChange}
//                                         required
//                                     >
//                                         <option value="">Sélectionnez une catégorie</option>
//                                         {categories.map((cat) => (
//                                             <option key={cat.id} value={cat.id}>
//                                                 {cat.libelle}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div className="form-group">
//                                     <label className="form-label">
//                                         <TagsOutlined className="label-icon" />
//                                         Sous-catégorie
//                                     </label>
//                                     <select
//                                         className="form-select"
//                                         value={liveTraining.subcategory?.id || ""}
//                                         onChange={(e) =>
//                                             setLiveTraining((prev) => ({
//                                                 ...prev,
//                                                 subcategory: e.target.value
//                                                     ? { id: parseInt(e.target.value, 10) }
//                                                     : null,
//                                             }))
//                                         }
//                                         disabled={!subcategories.length}
//                                     >
//                                         <option value="">Sélectionnez une sous-catégorie</option>
//                                         {subcategories.map((sub) => (
//                                             <option key={sub.id} value={sub.id}>
//                                                 {sub.libelle}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* SECTION 3 : Aperçu */}
//                     <div className="form-section">
//                         <div className="section-header">
//                             <div className="section-icon info"><EyeOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Aperçu de la formation</h3>
//                                 <p>Présentez votre session live</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="editor-wrapper">
//                                 <Editor
//                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                     value={liveTraining.overview}
//                                     init={{
//                                         height: 280,
//                                         menubar: false,
//                                         plugins: ["link", "lists", "table", "paste", "code"],
//                                         toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link",
//                                     }}
//                                     onEditorChange={(content) =>
//                                         handleInputChange({ target: { name: "overview", value: content } })
//                                     }
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* SECTION 4 : Contenu */}
//                     <div className="form-section">
//                         <div className="section-header">
//                             <div className="section-icon purple"><RocketOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Ce que vous allez apprendre</h3>
//                                 <p>Compétences acquises</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="editor-wrapper">
//                                 <Editor
//                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                     value={liveTraining.what_you_will_learn}
//                                     init={{
//                                         height: 250,
//                                         menubar: false,
//                                         plugins: ["link", "lists", "paste"],
//                                         toolbar: "undo redo | bold italic | bullist numlist",
//                                     }}
//                                     onEditorChange={(content) =>
//                                         handleInputChange({ target: { name: "what_you_will_learn", value: content } })
//                                     }
//                                 />
//                             </div>

//                             <div className="form-group" style={{ marginTop: 24 }}>
//                                 <label className="form-label">
//                                     <FileTextOutlined className="label-icon" />
//                                     Prérequis
//                                 </label>
//                                 <div className="editor-wrapper">
//                                     <Editor
//                                         apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                         value={liveTraining.requirements}
//                                         init={{
//                                             height: 200,
//                                             menubar: false,
//                                             plugins: ["link", "lists", "paste"],
//                                             toolbar: "undo redo | bold italic | bullist numlist",
//                                         }}
//                                         onEditorChange={(content) =>
//                                             handleInputChange({ target: { name: "requirements", value: content } })
//                                         }
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* SECTION 5 : Public cible */}
//                     <div className="form-section">
//                         <div className="section-header">
//                             <div className="section-icon pink"><TeamOutlined /></div>
//                             <div className="section-title-group">
//                                 <h3>Public cible</h3>
//                                 <p>À qui s'adresse cette formation ?</p>
//                             </div>
//                         </div>
//                         <div className="section-content">
//                             <div className="editor-wrapper">
//                                 <Editor
//                                     apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
//                                     value={liveTraining.who_is_this_course_for}
//                                     init={{
//                                         height: 200,
//                                         menubar: false,
//                                         plugins: ["link", "lists", "paste"],
//                                         toolbar: "undo redo | bold italic | bullist numlist",
//                                     }}
//                                     onEditorChange={(content) =>
//                                         handleInputChange({ target: { name: "who_is_this_course_for", value: content } })
//                                     }
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* SUBMIT */}
//                     <div className="submit-section">
//                         <div className="submit-info">
//                             <InfoCircleOutlined style={{ color: C.blue }} />
//                             <span>Les champs marqués d'un <span style={{ color: "#ff4d4f" }}>*</span> sont obligatoires</span>
//                         </div>
//                         <div className="submit-actions">
//                             {onClose && (
//                                 <button type="button" className="btn btn-secondary" onClick={onClose}>
//                                     Annuler
//                                 </button>
//                             )}
//                             <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
//                                 {isSubmitting ? (
//                                     <><Spin size="small" /> Envoi...</>
//                                 ) : (
//                                     <><SaveOutlined /> {editId ? "Mettre à jour" : "Créer la formation Live"}</>
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default LiveTrainingForm;


import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { message, Spin } from "antd";
import {
    BookOutlined,
    FileImageOutlined,
    TagsOutlined,
    EyeOutlined,
    EditOutlined,
    SaveOutlined,
    InfoCircleOutlined,
    ClockCircleOutlined,
    TeamOutlined,
    FileTextOutlined,
    RocketOutlined,
    DollarOutlined,
    VideoCameraOutlined,
} from "@ant-design/icons";
import courseService from "../../../services/course.service";
import liveTrainingService from "../../../services/liveTraining.service";

// 🎨 COULEURS NOMIDYA
const C = {
    blue: "#0054A6",
    blueDark: "#003B75",
    blueDeep: "#002147",
    orange: "#E8860C",
    orangeLight: "#FF8C00",
    orangeDark: "#C46F0A",
};

const INITIAL_VALUE = {
    title: "",
    image: "",
    duration: "",
    short_desc: "",
    overview: "",
    requirements: "",
    what_you_will_learn: "",
    who_is_this_course_for: "",
    price: 0,
};

const LiveTrainingForm = ({ btnText, initialData, onClose, onSaved }) => {
    const { id: paramId } = useParams();
    const editId = initialData?.id || paramId;

    const [liveTraining, setLiveTraining] = useState(INITIAL_VALUE);
    const [imagePreview, setImagePreview] = useState("");
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [imageFile, setImageFile] = useState(null);

    const calculateProgress = () => {
        let filled = 0;
        const total = 4;
        if (liveTraining.title) filled++;
        if (liveTraining.short_desc) filled++;
        if (selectedCategory) filled++;
        if (liveTraining.price > 0) filled++;
        return Math.round((filled / total) * 100);
    };

    // ⭐ Charger les données en mode édition
    useEffect(() => {
        if (editId) {
            const fetchData = async () => {
                try {
                    setIsLoadingData(true);
                    console.log("📡 Chargement de la formation ID:", editId);
                    const fullData = await (
                        liveTrainingService.getByIdForAdmin
                            ? liveTrainingService.getByIdForAdmin(editId)
                            : liveTrainingService.getById(editId)
                    );
                    console.log("✅ Données chargées:", fullData);

                    setLiveTraining({
                        ...INITIAL_VALUE,
                        ...fullData,
                    });
                    setImagePreview(fullData.image || "");
                    setSelectedCategory(fullData.category?.id || "");

                    if (fullData.category?.id) {
                        const subs = await courseService.getSubcategories(fullData.category.id);
                        setSubcategories(subs);
                    }
                } catch (error) {
                    console.error("❌ Erreur chargement formation live:", error);
                    message.error("Erreur lors du chargement de la formation");
                } finally {
                    setIsLoadingData(false);
                }
            };
            fetchData();
        }
    }, [editId]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await courseService.getCategories();
                if (Array.isArray(response)) {
                    setCategories(response);
                }
            } catch (error) {
                console.error("Erreur chargement catégories:", error);
            }
        };
        fetchCategories();
    }, []);

    const handleCategoryChange = async (e) => {
        const categoryId = e.target.value;
        setSelectedCategory(categoryId);
        setLiveTraining((prev) => ({ ...prev, category: { id: categoryId } }));

        try {
            const response = await courseService.getSubcategories(categoryId);
            setSubcategories(response);
        } catch (error) {
            console.error("Erreur sous-catégories:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, files, type } = e.target;
        if (name === "image" && files && files.length > 0) {
            setImageFile(files[0]);
            setImagePreview(URL.createObjectURL(files[0]));
        } else {
            let processedValue = value;
            if (type === "number") {
                processedValue = value === "" ? 0 : parseFloat(value) || 0;
            }
            setLiveTraining((prev) => ({ ...prev, [name]: processedValue }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!liveTraining.title) {
            message.error("Veuillez fournir un titre");
            return;
        }
        if (!selectedCategory) {
            message.error("Veuillez sélectionner une catégorie");
            return;
        }
        if (!editId && !imageFile) {
            message.error("Veuillez fournir une image");
            return;
        }

        try {
            setIsSubmitting(true);

            const dataToSend = {
                ...liveTraining,
                // ⭐ On force price à être un Number propre (jamais une string),
                // sinon Jackson peut mal le désérialiser côté Spring Boot.
                price: Number(liveTraining.price) || 0,
                category: { id: selectedCategory },
                subcategory:
                    liveTraining.subcategory?.id
                        ? { id: liveTraining.subcategory.id }
                        : null,
            };

            // ⭐⭐ CORRECTION CRITIQUE ⭐⭐
            // L'image Base64 ne doit JAMAIS partir dans le JSON (paramètre multipart).
            // En mode édition, liveTraining.image contient le Base64 complet de l'image
            // existante (souvent > 1 Mo). Envoyé en paramètre POST, il dépasse la limite
            // maxPostSize du connecteur Tomcat -> MultipartException -> "[object Object]".
            //
            // L'image transite UNIQUEMENT via imageFile (partie "file" du multipart).
            // Le backend conserve l'image existante si aucun nouveau fichier n'est fourni.
            delete dataToSend.image;

            // 🔍 LOG TEMPORAIRE DE DIAGNOSTIC — à retirer une fois le prix corrigé
            console.log("💰 PRIX ENVOYÉ:", dataToSend.price, typeof dataToSend.price);
            console.log("📦 PAYLOAD COMPLET:", JSON.stringify(dataToSend));

            if (editId) {
                await liveTrainingService.updateLiveTraining(editId, dataToSend, imageFile);
                message.success("Formation live mise à jour avec succès !");
            } else {
                await liveTrainingService.createLiveTraining(dataToSend, imageFile);
                message.success("Formation live créée avec succès !");
            }

            if (onSaved) {
                onSaved();
            } else {
                setTimeout(() => {
                    navigate("/mod/live-trainings", { replace: true });
                }, 1500);
            }
        } catch (error) {
            console.error("Erreur soumission:", error);
            message.error(error.message || "Erreur lors de l'opération");
        } finally {
            setIsSubmitting(false);
        }
    };

    const progress = calculateProgress();

    return (
        <div style={{ minHeight: "100vh", background: "#f0f2f5", padding: "0" }}>
            <style>{`
                :root {
                    --primary-color: ${C.blue};
                    --orange: ${C.orange};
                    --success-color: #52c41a;
                    --error-color: #ff4d4f;
                    --text-primary: #262626;
                    --text-secondary: #595959;
                    --text-muted: #8c8c8c;
                    --border-color: #d9d9d9;
                    --bg-light: #fafafa;
                    --shadow-sm: 0 1px 2px rgba(0,0,0,0.03), 0 1px 6px -1px rgba(0,0,0,0.02);
                    --shadow-md: 0 6px 16px rgba(0,84,166,0.1);
                    --radius-md: 8px;
                    --radius-lg: 12px;
                }

                .live-form-header {
                    background: linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%);
                    padding: 24px 32px;
                    color: white;
                    position: sticky;
                    top: 0;
                    z-index: 100;
                    box-shadow: 0 4px 20px rgba(0,84,166,0.25);
                    overflow: hidden;
                }
                .live-form-header::before {
                    content: '';
                    position: absolute;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    background-image: radial-gradient(circle at 80% 30%, ${C.orange}22 0%, transparent 50%);
                    pointer-events: none;
                }

                .header-content {
                    max-width: 1400px;
                    margin: 0 auto;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 16px;
                    position: relative;
                    z-index: 1;
                }

                .header-title {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .header-title h1 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: 600;
                }

                .header-title .icon {
                    font-size: 28px;
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    padding: 8px;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px ${C.orange}66;
                }

                .live-badge {
                    background: rgba(255,0,0,0.95);
                    padding: 4px 12px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                }
                .live-badge::before {
                    content: '';
                    width: 8px;
                    height: 8px;
                    background: white;
                    border-radius: 50%;
                    animation: pulse 1.5s infinite;
                }
                @keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }

                .progress-indicator {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    background: rgba(255,255,255,0.15);
                    padding: 8px 16px;
                    border-radius: 20px;
                    backdrop-filter: blur(10px);
                }

                .progress-bar-container {
                    width: 120px;
                    height: 6px;
                    background: rgba(255,255,255,0.3);
                    border-radius: 3px;
                    overflow: hidden;
                }

                .progress-bar-fill {
                    height: 100%;
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    border-radius: 3px;
                    transition: width 0.3s ease;
                }

                .progress-text {
                    font-size: 13px;
                    font-weight: 500;
                }

                .live-form-container {
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 24px;
                }

                .form-section {
                    background: white;
                    border-radius: var(--radius-lg);
                    box-shadow: var(--shadow-sm);
                    border: 1px solid #f0f0f0;
                    overflow: hidden;
                    margin-bottom: 24px;
                    transition: box-shadow 0.2s ease;
                }
                .form-section:hover {
                    box-shadow: var(--shadow-md);
                }

                .section-header {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    padding: 20px 24px;
                    border-bottom: 1px solid #f0f0f0;
                    background: var(--bg-light);
                }

                .section-icon {
                    width: 44px;
                    height: 44px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    color: white;
                }

                .section-icon.live { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
                .section-icon.primary { background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%); }
                .section-icon.success { background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%); }
                .section-icon.warning { background: linear-gradient(135deg, #faad14 0%, #d48806 100%); }
                .section-icon.info { background: linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%); }
                .section-icon.purple { background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%); }
                .section-icon.pink { background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%); }

                .section-title-group h3 {
                    margin: 0 0 4px 0;
                    font-size: 17px;
                    font-weight: 600;
                    color: var(--text-primary);
                }
                .section-title-group p {
                    margin: 0;
                    font-size: 13px;
                    color: var(--text-muted);
                }

                .section-content { padding: 24px; }

                .form-row {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 20px;
                }

                .form-group { margin-bottom: 20px; }
                .form-group:last-child { margin-bottom: 0; }

                .form-label {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 8px;
                    font-size: 14px;
                    font-weight: 500;
                    color: var(--text-primary);
                }
                .form-label .required { color: var(--error-color); }
                .form-label .label-icon {
                    color: ${C.blue};
                    font-size: 16px;
                }

                .form-input, .form-select, .form-textarea {
                    width: 100%;
                    padding: 10px 14px;
                    border: 1px solid var(--border-color);
                    border-radius: var(--radius-md);
                    font-size: 14px;
                    color: var(--text-primary);
                    background: white;
                    transition: all 0.2s ease;
                    box-sizing: border-box;
                }
                .form-input:focus, .form-select:focus, .form-textarea:focus {
                    outline: none;
                    border-color: ${C.blue};
                    box-shadow: 0 0 0 2px ${C.blue}22;
                }
                .form-textarea {
                    resize: vertical;
                    min-height: 100px;
                }

                .image-upload-area {
                    border: 2px dashed var(--border-color);
                    border-radius: var(--radius-md);
                    padding: 24px;
                    text-align: center;
                    cursor: pointer;
                    background: var(--bg-light);
                    transition: all 0.2s ease;
                }
                .image-upload-area:hover {
                    border-color: ${C.blue};
                    background: #f0f7ff;
                }
                .image-upload-area input[type="file"] { display: none; }

                .upload-icon {
                    font-size: 40px;
                    color: ${C.blue};
                    margin-bottom: 12px;
                }
                .upload-text { font-size: 14px; color: var(--text-secondary); }
                .upload-hint { font-size: 12px; color: var(--text-muted); margin-top: 6px; }

                .image-preview {
                    max-width: 200px;
                    max-height: 150px;
                    border-radius: var(--radius-md);
                    box-shadow: var(--shadow-sm);
                    margin-top: 16px;
                    border: 1px solid #f0f0f0;
                }

                .editor-wrapper {
                    border: 1px solid var(--border-color);
                    border-radius: var(--radius-md);
                    overflow: hidden;
                }
                .editor-wrapper:focus-within {
                    border-color: ${C.blue};
                    box-shadow: 0 0 0 2px ${C.blue}22;
                }

                .price-input-group { position: relative; }
                .price-input-group .currency-symbol {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: ${C.orange};
                    font-weight: 700;
                }
                .price-input-group .form-input { padding-left: 32px; }

                .submit-section {
                    background: white;
                    border-radius: var(--radius-lg);
                    box-shadow: var(--shadow-sm);
                    border: 1px solid #f0f0f0;
                    padding: 24px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 16px;
                }

                .submit-info {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    color: var(--text-muted);
                    font-size: 14px;
                }

                .submit-actions { display: flex; gap: 12px; }

                .btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 12px 28px;
                    border-radius: var(--radius-md);
                    font-size: 15px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    border: none;
                    min-width: 160px;
                }

                .btn-primary {
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    color: white;
                    box-shadow: 0 4px 12px ${C.orange}66;
                }
                .btn-primary:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px ${C.orange}88;
                    background: linear-gradient(135deg, ${C.orangeDark} 0%, ${C.orange} 100%);
                }
                .btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

                .btn-secondary {
                    background: white;
                    color: ${C.blue};
                    border: 2px solid ${C.blue};
                }
                .btn-secondary:hover {
                    background: #f0f7ff;
                    border-color: ${C.blueDark};
                    color: ${C.blueDark};
                }

                .loading-overlay {
                    position: fixed;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    background: rgba(0,33,71,0.45);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                    backdrop-filter: blur(4px);
                }

                .loading-card {
                    background: white;
                    padding: 40px 50px;
                    border-radius: var(--radius-lg);
                    text-align: center;
                    box-shadow: 0 20px 40px rgba(0,84,166,0.25);
                }

                .loading-text {
                    margin-top: 20px;
                    font-size: 16px;
                    font-weight: 500;
                    color: ${C.blueDark};
                }

                @media (max-width: 768px) {
                    .live-form-header { padding: 16px 20px; }
                    .header-title h1 { font-size: 18px; }
                    .live-form-container { padding: 16px; }
                    .section-content { padding: 16px; }
                    .form-row { grid-template-columns: 1fr; }
                    .submit-section { flex-direction: column; align-items: stretch; }
                    .submit-actions { flex-direction: column; }
                    .btn { width: 100%; }
                }
            `}</style>

            {/* ⭐ LOADER PENDANT LE CHARGEMENT DES DONNÉES (mode édition) */}
            {isLoadingData && (
                <div className="loading-overlay">
                    <div className="loading-card">
                        <Spin size="large" />
                        <div className="loading-text">
                            Chargement de la formation...
                        </div>
                        <div style={{ marginTop: 8, fontSize: 13, color: '#9ca3af' }}>
                            Veuillez patienter quelques instants
                        </div>
                    </div>
                </div>
            )}

            {/* Loading Overlay */}
            {isSubmitting && (
                <div className="loading-overlay">
                    <div className="loading-card">
                        <Spin size="large" />
                        <div className="loading-text">
                            {editId ? "Mise à jour en cours..." : "Création en cours..."}
                        </div>
                    </div>
                </div>
            )}

            {/* Header BLEU NOMIDYA */}
            <div className="live-form-header">
                <div className="header-content">
                    <div className="header-title">
                        <span className="icon"><VideoCameraOutlined /></span>
                        <div>
                            <h1>{editId ? `Modifier : ${liveTraining.title || ""}` : "Créer une Formation Live"}</h1>
                            <span className="live-badge">LIVE</span>
                        </div>
                    </div>
                    <div className="progress-indicator">
                        <span className="progress-text">Progression</span>
                        <div className="progress-bar-container">
                            <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
                        </div>
                        <span className="progress-text">{progress}%</span>
                    </div>
                </div>
            </div>

            <div className="live-form-container">
                <form onSubmit={handleSubmit}>

                    {/* SECTION 1 : Informations principales */}
                    <div className="form-section">
                        <div className="section-header">
                            <div className="section-icon primary"><BookOutlined /></div>
                            <div className="section-title-group">
                                <h3>Informations principales</h3>
                                <p>Titre, prix, image et description</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        <EditOutlined className="label-icon" />
                                        Titre <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="title"
                                        className="form-input"
                                        value={liveTraining.title}
                                        onChange={handleInputChange}
                                        placeholder="Ex: Masterclass SAP S/4HANA Live"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        <DollarOutlined className="label-icon" />
                                        Prix de la formation <span className="required">*</span>
                                    </label>
                                    <div className="price-input-group">
                                        <span className="currency-symbol">€</span>
                                        <input
                                            type="number"
                                            name="price"
                                            className="form-input"
                                            value={liveTraining.price}
                                            onChange={handleInputChange}
                                            min="0"
                                            step="0.01"
                                            placeholder="Ex: 99.99"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    <FileImageOutlined className="label-icon" />
                                    Image de couverture {!editId && <span className="required">*</span>}
                                </label>
                                <label className="image-upload-area">
                                    <input
                                        type="file"
                                        name="image"
                                        onChange={handleInputChange}
                                        accept="image/*"
                                    />
                                    <div className="upload-icon"><FileImageOutlined /></div>
                                    <div className="upload-text">Cliquez pour télécharger</div>
                                    <div className="upload-hint">
                                        {editId
                                            ? "Laissez vide pour conserver l'image actuelle"
                                            : "PNG, JPG jusqu'à 5MB"}
                                    </div>
                                </label>
                                {imagePreview && (
                                    <img src={imagePreview} alt="Preview" className="image-preview" />
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    <FileTextOutlined className="label-icon" />
                                    Description courte
                                </label>
                                <textarea
                                    name="short_desc"
                                    className="form-textarea"
                                    value={liveTraining.short_desc}
                                    onChange={handleInputChange}
                                    placeholder="Décrivez votre formation live..."
                                    rows="3"
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">
                                    <ClockCircleOutlined className="label-icon" />
                                    Durée totale
                                </label>
                                <input
                                    type="text"
                                    name="duration"
                                    className="form-input"
                                    value={liveTraining.duration}
                                    onChange={handleInputChange}
                                    placeholder="Ex: 3h, 2 jours"
                                />
                            </div>
                        </div>
                    </div>

                    {/* SECTION 2 : Catégorisation */}
                    <div className="form-section">
                        <div className="section-header">
                            <div className="section-icon warning"><TagsOutlined /></div>
                            <div className="section-title-group">
                                <h3>Catégorisation</h3>
                                <p>Classez votre formation</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        <TagsOutlined className="label-icon" />
                                        Catégorie <span className="required">*</span>
                                    </label>
                                    <select
                                        className="form-select"
                                        value={selectedCategory || ""}
                                        onChange={handleCategoryChange}
                                        required
                                    >
                                        <option value="">Sélectionnez une catégorie</option>
                                        {categories.map((cat) => (
                                            <option key={cat.id} value={cat.id}>
                                                {cat.libelle}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        <TagsOutlined className="label-icon" />
                                        Sous-catégorie
                                    </label>
                                    <select
                                        className="form-select"
                                        value={liveTraining.subcategory?.id || ""}
                                        onChange={(e) =>
                                            setLiveTraining((prev) => ({
                                                ...prev,
                                                subcategory: e.target.value
                                                    ? { id: parseInt(e.target.value, 10) }
                                                    : null,
                                            }))
                                        }
                                        disabled={!subcategories.length}
                                    >
                                        <option value="">Sélectionnez une sous-catégorie</option>
                                        {subcategories.map((sub) => (
                                            <option key={sub.id} value={sub.id}>
                                                {sub.libelle}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* SECTION 3 : Aperçu */}
                    <div className="form-section">
                        <div className="section-header">
                            <div className="section-icon info"><EyeOutlined /></div>
                            <div className="section-title-group">
                                <h3>Aperçu de la formation</h3>
                                <p>Présentez votre session live</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="editor-wrapper">
                                <Editor
                                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                    value={liveTraining.overview}
                                    init={{
                                        height: 280,
                                        menubar: false,
                                        plugins: ["link", "lists", "table", "paste", "code"],
                                        toolbar: "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | link",
                                    }}
                                    onEditorChange={(content) =>
                                        handleInputChange({ target: { name: "overview", value: content } })
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    {/* SECTION 4 : Contenu */}
                    <div className="form-section">
                        <div className="section-header">
                            <div className="section-icon purple"><RocketOutlined /></div>
                            <div className="section-title-group">
                                <h3>Ce que vous allez apprendre</h3>
                                <p>Compétences acquises</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="editor-wrapper">
                                <Editor
                                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                    value={liveTraining.what_you_will_learn}
                                    init={{
                                        height: 250,
                                        menubar: false,
                                        plugins: ["link", "lists", "paste"],
                                        toolbar: "undo redo | bold italic | bullist numlist",
                                    }}
                                    onEditorChange={(content) =>
                                        handleInputChange({ target: { name: "what_you_will_learn", value: content } })
                                    }
                                />
                            </div>

                            <div className="form-group" style={{ marginTop: 24 }}>
                                <label className="form-label">
                                    <FileTextOutlined className="label-icon" />
                                    Prérequis
                                </label>
                                <div className="editor-wrapper">
                                    <Editor
                                        apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                        value={liveTraining.requirements}
                                        init={{
                                            height: 200,
                                            menubar: false,
                                            plugins: ["link", "lists", "paste"],
                                            toolbar: "undo redo | bold italic | bullist numlist",
                                        }}
                                        onEditorChange={(content) =>
                                            handleInputChange({ target: { name: "requirements", value: content } })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* SECTION 5 : Public cible */}
                    <div className="form-section">
                        <div className="section-header">
                            <div className="section-icon pink"><TeamOutlined /></div>
                            <div className="section-title-group">
                                <h3>Public cible</h3>
                                <p>À qui s'adresse cette formation ?</p>
                            </div>
                        </div>
                        <div className="section-content">
                            <div className="editor-wrapper">
                                <Editor
                                    apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                                    value={liveTraining.who_is_this_course_for}
                                    init={{
                                        height: 200,
                                        menubar: false,
                                        plugins: ["link", "lists", "paste"],
                                        toolbar: "undo redo | bold italic | bullist numlist",
                                    }}
                                    onEditorChange={(content) =>
                                        handleInputChange({ target: { name: "who_is_this_course_for", value: content } })
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    {/* SUBMIT */}
                    <div className="submit-section">
                        <div className="submit-info">
                            <InfoCircleOutlined style={{ color: C.blue }} />
                            <span>Les champs marqués d'un <span style={{ color: "#ff4d4f" }}>*</span> sont obligatoires</span>
                        </div>
                        <div className="submit-actions">
                            {onClose && (
                                <button type="button" className="btn btn-secondary" onClick={onClose}>
                                    Annuler
                                </button>
                            )}
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                {isSubmitting ? (
                                    <><Spin size="small" /> Envoi...</>
                                ) : (
                                    <><SaveOutlined /> {editId ? "Mettre à jour" : "Créer la formation Live"}</>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LiveTrainingForm;
